import {Calendar} from 'primereact/calendar';
import {addLocale, locale} from 'primereact/api';
import React, {useEffect} from 'react';

type DatePickerProps = {
  id?: string;
  value?: string;
  onChange: (value: string) => void;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  className?: string;
  placeholder?: string;
  showIcon?: boolean;
  showButtonBar?: boolean;
  disabled?: boolean;
};

const formatDate = (value?: Date | null) => (value ? value.toLocaleDateString('ru-RU') : '');
const parseDate = (value?: string) => {
  if (!value || !value.trim()) {
    return null;
  }
  const parts = value.trim().split('.');
  if (parts.length !== 3) {
    return null;
  }
  const day = Number(parts[0]);
  const month = Number(parts[1]);
  const year = Number(parts[2]);
  if (!Number.isFinite(day) || !Number.isFinite(month) || !Number.isFinite(year)) {
    return null;
  }
  const parsed = new Date(year, month - 1, day);
  if (parsed.getFullYear() !== year || parsed.getMonth() !== month - 1 || parsed.getDate() !== day) {
    return null;
  }
  return parsed;
};

export const DatePicker = ({
  id,
  value,
  onChange,
  onBlur,
  className,
  placeholder = 'ДД.ММ.ГГГГ',
  showIcon = true,
  showButtonBar = true,
  disabled = false,
}: DatePickerProps) => {
  useEffect(() => {
    addLocale('ru', {
      firstDayOfWeek: 1,
      dayNames: ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота'],
      dayNamesShort: ['вск', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
      dayNamesMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
      monthNames: [
        'январь',
        'февраль',
        'март',
        'апрель',
        'май',
        'июнь',
        'июль',
        'август',
        'сентябрь',
        'октябрь',
        'ноябрь',
        'декабрь',
      ],
      monthNamesShort: [
        'янв',
        'фев',
        'мар',
        'апр',
        'май',
        'июн',
        'июл',
        'авг',
        'сен',
        'окт',
        'ноя',
        'дек',
      ],
      today: 'Сегодня',
      clear: 'Очистить',
    });
    locale('ru');
  }, []);

  return (
    <Calendar
      id={id}
      value={parseDate(value)}
      dateFormat="dd.mm.yy"
      placeholder={placeholder}
      className={className}
      showIcon={showIcon}
      showButtonBar={showButtonBar}
      disabled={disabled}
      onBlur={onBlur}
      onChange={(e) => onChange(formatDate(e.value))}
    />
  );
};
